/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Transcript_FailedInputs */



/**
* | output |
* | --- |
* | "We could not load the conversation. Please try again in a moment." |
*
* @param {Practice_Transcript_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_transcript_failed = /** @type {((inputs?: Practice_Transcript_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Transcript_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We konden het gesprek niet laden. Probeer het zo meteen opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons pas pu charger l'entretien. Réessayez dans un instant.")
	return /** @type {LocalizedString} */ ("We could not load the conversation. Please try again in a moment.")
});